export default __webpack_public_path__ + "static/media/axe.241f2aa2.png";